import { Component, Input, OnInit } from '@angular/core';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { DialogService } from '../../../core/services/dialog.service';
import { NuoveEmissioniService } from '../../../core/services/tables/nuove-emissioni.service';
import { NuoviInQuotazione } from '../../../models/NuoviInQuotazione';
import { DataStatus } from 'src/app/models/Helpers/data-status';
import { Loader } from 'src/app/models/Helpers/loader';
import {animate, style, transition, trigger, state} from '@angular/animations';
import {AddToWatchlistManagerService} from '../../../core/services/watchlists/add-to-watchlist-manager.service';

@Component({
  selector: 'app-nuovi-in-quotazione',
  templateUrl: './nuovi-in-quotazione.component.html',
  styleUrls: ['./nuovi-in-quotazione.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0, padding: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class NuoviInQuotazioneComponent implements OnInit {

  @Input() userRole: string;

  TABLE_TITLE = 'Nuovi in Quotazione';
  VIEW_ALL_PATH = '/menu/nuovi-in-quotazione';
  TABLE_SORT_HEADERS: Array<[string, string]> = [
    ['Isin', 'Isin'],
    ['Nome', 'Nome'],
    ['Demit', 'Emittente'],
    ['Dsott', 'Sottostante'],
    ['Dmercato', 'Mercato'],
    ['DataNeg', 'Data'],
    ['Scadenza', 'Scadenza']
  ];

  records: NuoviInQuotazione[];
  dataStatus = new DataStatus();
  loader = new Loader();

  sortingFilter: string;
  sortingAscending: boolean;

  tableInfoExists: boolean;

  state = 'collapsed';

  constructor(
    private service: NuoveEmissioniService,
    private infoService: InfoService,
    public dialogService: DialogService,
    private addToWatchlistManager: AddToWatchlistManagerService,
  ) { }

  ngOnInit(): void {
    if (!this.userRole) { throw new Error('User role is unknown'); }

    this.tableInfoExists = this.infoService.isThereInfo(this.TABLE_TITLE);
  }

  private async getRecords() {
    this.dataStatus.resetStatus();
    this.loader.show();

    const result = await this.service.get(1, 10, this.sortingFilter, this.sortingAscending)
      .catch(error => {
        console.log('ERROR IN HOME -> NUOVE EMISSIONI -> GET', error);
        this.dataStatus
          .setStatus('failure')
          .setAlertMessage('Errore nel caricamento dei dati')
          .setAlertClasses(['cedlab-danger']);
        this.loader.hide();
      });
    if (!result) { return; }

    if (result.totalRecords > 0) {
      this.records = result.records;
      this.dataStatus.setStatus('success');
    } else {
      this.records = [];
      this.dataStatus
        .setStatus('info')
        .setAlertMessage('Nessun isin presente')
        .setAlertClasses(['cedlab-info']);
    }
    this.loader.hide();
  }

  public triggerSorting({ active, direction }) {

    if (this.userIsGuest()) { return; }

    this.sortingFilter = active;
    switch (direction) {
      case 'asc':
        this.sortingAscending = true;
        break;
      case 'desc':
        this.sortingAscending = false;
        break;
      default: this.sortingAscending = null;
    }

    this.getRecords().then();
  }

  public addIsinToWatchlist(isin: string) {
    if (this.userIsGuest()) {
      this.dialogService.openFailureSnackBar('Abbonati ai servizi CedLab per usufruire dell\'esperienza completa');
      return;
    }

    this.addToWatchlistManager.addToWatchlist(isin);
  }


  private userIsGuest = () => this.userRole === 'CedLabGuest';
  public openInfoDialog() {
    const tableInfo = this.infoService.getTableInfo(this.TABLE_TITLE);
    this.dialogService.openTableInfoDialog(tableInfo);
  }

  toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    if (this.state === 'expanded') {
      this.getRecords().then();
    }
  }
}
